// extracted by mini-css-extract-plugin
export default {"component":"r4rbO","image":"hFaVI","rotation":"K82GC"};